import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { StyledBlackInformationTypography, StyledMainBox, StyledNestedTabs } from "../../../../components/commonComponents/StyledComponents/styled";
import { Box, Tab } from "@mui/material";
import PropTypes from "prop-types";
import AvailableWorkspaceSection from "./AvailableWorkspaceSection";
import ArchivedWorkspaceSections from "./ArchivedWorkspaceSections";

// to load tab content
function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`nested-tabpanel-${index}`}
            aria-labelledby={`nested-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `nested-tab-${index}`,
        "aria-controls": `nested-tabpanel-${index}`,
    };
}

const PerformanceWorkspace = () => {
    const currentStateData = useSelector((state) => state.userSelections);
    const dispatchAction = useDispatch();

    const [nestedValue, setNestedValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setNestedValue(newValue);
    };

    let tabs = [
        {
            label: "Available Sections",
            // icon: <Visibility />,
            unique_key: "workspace_available_sections",
            content: <AvailableWorkspaceSection />,
        },
        {
            label: "Archived Sections",
            // icon: <Visibility />,
            unique_key: "workspace_archived_sections",
            content: <ArchivedWorkspaceSections />,
        },
    ];

    return (
        <>
            <Box height={10} />
            <StyledBlackInformationTypography variant="body2" sx={{ marginLeft: 0, fontWeight: "normal" }}>
                Performance sections include all dashboards which are not automatically published Impressions dashboards. You may add as many sections as you like.
            </StyledBlackInformationTypography>
            <Box height={20} />
            <StyledNestedTabs value={nestedValue} onChange={handleChange} aria-label="brand analytics" textColor={"#F04B55"}>
                {tabs.map((tabDetail) => {
                    return <Tab key={tabDetail.unique_key} aria-label={tabDetail.label} label={tabDetail.label} {...a11yProps(0)} />;
                })}
            </StyledNestedTabs>

            {/* ============== tab contents =========== */}
            {tabs.map((tabDetail, index) => {
                return (
                    <CustomTabPanel value={nestedValue} index={index}>
                        {tabDetail.content}
                    </CustomTabPanel>
                );
            })}
        </>
    );
};

export default PerformanceWorkspace;
